/* eslint-disable no-restricted-globals */
const hostname = self.location.hostname;
const isLocal = hostname === 'localhost' || hostname === 'pamova.local' || hostname.endsWith('.local') || hostname === '127.0.0.1';

export const MODE = isLocal ? 'dev' : (hostname.includes('duckdns.org') ? 'test' : 'live'); // dev, test, live

const protocol = isLocal ? 'http:' : 'https:';

const CONFIGS = {
    dev: {
        URL: `${protocol}//${hostname}${self.location.port ? ':' + self.location.port : ''}`,
        API_URL: `http://127.0.0.1/api`,
        DOMAIN: `${protocol}//${hostname}${self.location.port ? ':' + self.location.port : ''}`,
    },
    test: {
        URL: 'https://pam-tutor.duckdns.org',
        API_URL: 'https://pam-portal.duckdns.org/api',
        DOMAIN: 'https://pam-tutor.duckdns.org',
    },
    live: {
        URL: 'https://learn.pamova.com',
        API_URL: 'https://admin.pamova.com/api',
        DOMAIN: 'https://learn.pamova.com',
    },
};

export const URL = CONFIGS[MODE].URL;
export const API_URL = CONFIGS[MODE].API_URL;
export const DOMAIN = CONFIGS[MODE].DOMAIN;